var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { EntryComponent } from '../entry/entry.component';
import { ContentBaseService } from '../base/contentbase.service';
var TemplateComponent = /** @class */ (function (_super) {
    __extends(TemplateComponent, _super);
    function TemplateComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.count = 1;
        return _this;
    }
    TemplateComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    TemplateComponent.prototype.onSubscribe = function (data) {
        _super.prototype.onSubscribe.call(this, data);
        this.count = 1;
        if (this.cols[0] && this.cols[0].key && this.rec[this.cols[0].key]) {
            var val = this.rec[this.cols[0].key];
            var r = /\{\{input(\d+)\}\}/g;
            var m = void 0;
            while ((m = r.exec(val)) != null) {
                if (m[1] && this.count < parseInt(m[1])) {
                    this.count = parseInt(m[1]);
                }
            }
            this.count++;
        }
    };
    TemplateComponent.prototype.setContentsTag = function (key) {
        var element = document.getElementsByName(key)[0];
        var sentence = element.value;
        var len = sentence.length;
        var pos = element.selectionStart;
        var before = sentence.substr(0, pos);
        var after = sentence.substr(pos, len);
        var tag = "{{input" + this.count++ + "}}";
        sentence = before + tag + after;
        element.value = sentence;
        pos = (before + tag).length;
        element.setSelectionRange(pos, pos);
        element.focus();
        _super.prototype.onChange.call(this, { key: key, val: sentence });
    };
    TemplateComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'contents-template',
                    template: "<form id=\"{{ componentName }}\">\n  <ng-template ngFor let-col [ngForOf]=\"cols\" [ngForTrackBy]=\"trackByCol\" let-isFirst=\"first\">\n    <div *ngIf=\"isFirst\" class=\"row\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n        <dl *ngIf=\"!col.readonly\" class=\"form\">\n          <dt class=\"form_dt\"></dt>\n          <dd class=\"form_dd\">\n            <ul>\n              <li class=\"form_li\">\n                <a href=\"javascript:void(0);\" (click)=\"setContentsTag(col.key)\">{{ (msg | async)['au.COMPONENT.TemplateComponent.label.editTag'] }}</a>\n              </li>\n            </ul>\n          </dd>\n        </dl>\n      </div>\n    </div>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    TemplateComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return TemplateComponent;
}(EntryComponent));
export { TemplateComponent };
//# sourceMappingURL=template.component.js.map